import React from 'react';
import './results.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Administración de resultados'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;
